import { render, staticRenderFns } from "./login_login.vue?vue&type=template&id=475c8d2f&"
import script from "./login_login.vue?vue&type=script&lang=js&"
export * from "./login_login.vue?vue&type=script&lang=js&"
import style0 from "./login_login.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports